import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { WindowBase } from '../../services/window-dialogs/window.base';
import { KeyValuePair } from '../../../app/models/KeyValuePair';
import { NoteTypes, Note } from '../../../app/models/domain/note';
import { NoteManager, NoteManagerConstructor } from '../../../app/managers/note.manager';
import { License } from '../../../app/models/domain/license';
import { MemberEventsService } from '../../../app/services/member.events.service';
import { EntityChangedArgs } from '../../../app/managers/manager.base';
import { WindowEvent, WindowActionTypes } from '../../../app/services/window-dialogs/window.event';

export class NoteWindowData {
  NoteType : NoteTypes;
  NoteID : number;
  
}

@Component({
  selector: 'note-window',
  styleUrls: ['./note.window.scss'],
  templateUrl: './note.window.html'
})
export class NoteWindow extends WindowBase<NoteManagerConstructor> implements OnDestroy {
  [x: string]: any;

  noteData : NoteManagerConstructor;

  private noteChangeSubscription: Subscription;

  constructor( private memberEvents: MemberEventsService,
  ) {
    super();
  }


  ngOnDestroy() {

  }

  Init() {
    
    this.noteData = this.Context.Data
    console.log("Note DIALOG!!! Here's my noteData:", this.noteData);
    this.ShowNoteDialog();

    this.noteChangeSubscription = this.memberEvents.onNoteChanged.subscribe( args => this.onNoteChanged(args) );
    
  }

  Close() {
    this.InvokeEvent(WindowEvent.FromWindowContextResultOK(this.Context, WindowActionTypes.Close, true));
    window.close();
  }

  ShowNoteDialog() {

    let noteManager = new NoteManager( this.noteData );
    let disposable = noteManager.OnNoteSaved.subscribe( result => {
      console.log("note.window.ts -- OnNoteSaved response:", result);
    });

  }


  onNoteChanged(args: EntityChangedArgs<Note>) {

    this.InvokeEvent(WindowEvent.FromWindowContextResultOK(this.Context, WindowActionTypes.Saved, args));
    if(this.noteData.IsAddNote) {
      this.Close();
    }

  }


}